export default "__VITE_ASSET__DJ_Ej_rT__"